/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef } from "react"
import types from "prop-types"
import { useSelector } from "react-redux"
import { questionShape } from "utils/propTypeShapes"
import { getDraftAnswer } from "reduxSlices/taskDraftAnswersSlice"
import { FormsyMultiLineMentionableInput } from "shared/inputs"
import { users as formSubmissionUsers } from "reduxSlices/formSubmissionSlice"

const activeTaskUsers = (users, memberIds, assigneeIds) => users.filter((user) => [...memberIds, ...assigneeIds].includes(user.id) && user.active)

const MultiEntriesAnswerField = ({
  question,
  initialValue = null,
  disabled = false,
  taskId = undefined,
  memberIds = [],
  assigneeIds = [],
}) => {
  const answer = useRef(initialValue)

  const { required, uuid } = question

  const draftAnswer = useSelector(getDraftAnswer({ questionUuid: uuid, taskId }))
  const users = useSelector(formSubmissionUsers)

  useEffect(() => {
    if (draftAnswer !== null && draftAnswer !== undefined) {
      answer.current = draftAnswer
    }
  }, [draftAnswer, initialValue])

  return (
    <FormsyMultiLineMentionableInput
      users={activeTaskUsers(users, memberIds, assigneeIds)}
      className="multi-entries-answer-field"
      disabled={disabled}
      name={uuid}
      placeholder="Add an answer..."
      required={required}
      validations={{
        isNotBlankString: required,
        noExcelMetacharacters: true,
        noHTML: true,
      }}
      value={answer.current || ""}
    />
  )
}

MultiEntriesAnswerField.propTypes = {
  disabled: types.bool,
  initialValue: types.string,
  question: questionShape.isRequired,
  taskId: types.number,
  memberIds: types.arrayOf(types.number),
  assigneeIds: types.arrayOf(types.number),
}

export default MultiEntriesAnswerField
